import {
  State,
  StorefrontResponse,
  TransactionData,
  TransactionState,
} from '../../../types'

export const FETCH_TRANSACTION_PENDING =
  'transaction//FETCH_TRANSACTION_PENDING'

export const FETCH_TRANSACTION_DONE = 'transaction//FETCH_TRANSACTION_DONE'
export const FETCH_TRANSACTION_ERROR = 'transaction//FETCH_TRANSACTION_ERROR'

export interface FetchTransactionPendingAction {
  type: typeof FETCH_TRANSACTION_PENDING
  payload: Record<string, never>
}

export interface FetchTransactionDoneAction {
  type: typeof FETCH_TRANSACTION_DONE
  payload: { data: TransactionData }
}

export interface FetchTransactionErrorAction {
  type: typeof FETCH_TRANSACTION_ERROR
}

export type TransactionAction =
  | FetchTransactionPendingAction
  | FetchTransactionDoneAction
  | FetchTransactionErrorAction

export function pending(): FetchTransactionPendingAction {
  return {
    type: FETCH_TRANSACTION_PENDING,
    payload: {},
  }
}

export function done(data: StorefrontResponse): FetchTransactionDoneAction {
  return {
    type: FETCH_TRANSACTION_DONE,
    payload: { data: data as TransactionData },
  }
}

export function error(): FetchTransactionErrorAction {
  return {
    type: FETCH_TRANSACTION_ERROR,
  }
}

export function getTransactionData(store: State) {
  return store.transaction.data
}

const initialState: TransactionState = {
  pending: false,
  data: {} as TransactionData,
  error: null,
}

export default function transactionReducer(
  state: TransactionState = initialState,
  action: TransactionAction
): TransactionState {
  switch (action.type) {
    case FETCH_TRANSACTION_PENDING:
      return {
        ...state,
        data: {} as TransactionData,
        pending: true,
        error: null,
      }

    case FETCH_TRANSACTION_DONE:
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        error: null,
      }
    case FETCH_TRANSACTION_ERROR:
      return {
        ...state,
        data: {} as TransactionData,
        pending: false,
        error: true,
      }

    default:
      return state
  }
}
